export default __webpack_public_path__ + "234ce8f469fa952094c45708e23b8ced.svg";